import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  Grid,
  IconButton,
  Tooltip
} from "@mui/material";
import { ExpandLess, ManageSearch, Search } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import { t } from "i18next";
import api from "../../../helpers/api/Api";
import AppConfig from "../../../helpers/constants/AppConfig";
import { appendFormData } from "../../../helpers/functions/form-append";
import DataTable from "../DataTable";
import LoadingProgress from "../../LoadingProgress";
import DashboardLayout from "../../LayoutContainers/DashboardLayout";
import MDBox from "../../MDs/MDBox";
import MDTypography from "../../MDs/MDTypography";
import "./table.css";

function Table({ columns, rows, getListUrl, listReload, setDataList, itemName, itemPName, addUrl, search, formData, setFormData, listPermBit }) {
  const [loading, setLoading] = useState(true);
  const userPermission = useSelector(state => state.user_permission);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getList();
  }, [listReload]);

  const getList = (isSearch) => {
    setLoading(true);

    const fd = isSearch ? appendFormData(formData) : {};

    api.post(getListUrl, fd)
      .then((response) => {
        setDataList(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }

  const handleAccordion = (isOpen) => {
    if (isOpen === "search") {
      setOpen(!open);
    } else {
      setOpen(isOpen);
    }
  };

  useEffect(() => {
    if (search && !open) {
      let newFD = {};
      Object.entries(formData)
        .forEach(([key, value]) => {
          newFD[key] = "";
        });
      setFormData(newFD);
    }
  }, [open]);

  const onSearch = () => {
    getList(true);
  };

  return (
    <DashboardLayout>
      <MDBox pt={4} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>

            <Card>
              <MDBox
                 mx={2}
                 mt={-3}
                 py={3}
                 px={2}
                 variant="gradient"
                 bgColor={AppConfig.color}
                 borderRadius="lg"
                 className="table-with-button flex-column-md"
              >
                <MDTypography variant="h6" color="white">
                  {t("page.list", { item: itemPName })}
                </MDTypography>

                <div>
                  {search &&
                     <Tooltip title={t("button.search")} placement="top">
                       <IconButton
                          onClick={() => handleAccordion("search")}
                          sx={{ color: 'white' }}
                          className="ms-3 search-button"
                       >
                         <ManageSearch />
                       </IconButton>
                     </Tooltip>
                  }

                  {userPermission & listPermBit ?
                     <Button
                        variant="outlined" color={AppConfig.color} className="table-button"
                        href={addUrl}
                     >
                       {t("button.new_item", { item: itemName })}
                     </Button>
                     :
                     null
                  }
                </div>

              </MDBox>

              {search &&
                 <Accordion expanded={open} defaultExpanded={false} className="search-accordion">
                   <AccordionSummary sx={{ display: 'none' }} />
                   <AccordionDetails>
                     <div className="d-flex justify-content-between">
                       <h6 className="pb-2">{t("button.search")}</h6>

                       <IconButton onClick={() => handleAccordion(false)}>
                         <ExpandLess />
                       </IconButton>
                     </div>

                     <Grid container justifyContent="center" alignItems="center">
                       {search}

                       <Grid item md={2} xs={12} >
                         <LoadingButton
                            color="success"
                            loading={loading}
                            startIcon={<Search />}
                            variant="outlined"
                            fullWidth
                            onClick={onSearch}
                         >
                           {t("button.search")}
                         </LoadingButton>
                       </Grid>
                     </Grid>
                   </AccordionDetails>
                 </Accordion>
              }

              {loading ?
                 <LoadingProgress />
                 : (
                    <MDBox pt={3}>
                      <DataTable
                         table={{ columns, rows }}
                         isSorted={false}
                         noEndBorder
                         showTotalEntries={false}
                         entriesPerPage={{ defaultValue: 100 }}
                      />
                    </MDBox>
                 )
              }

            </Card>

          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Table;
